import React from 'react';
import { Translate, withLocalize } from 'react-localize-redux';
import { isNullOrUndefined } from '../../../store/storeFunctions';
import NoDataComponent from "../../common/noDataComponent";
import PropTypes from 'prop-types';
import RatingCard from '../rating/ratingCard';
import ReactHtmlParser from 'react-html-parser';
import EsgLine from './esgLine';

const ESG_SUBFACTOR_TYPE = {
    emmisionsE: "emmisions_E",
    energyEfficiencyE: "energy_efficiency_E",
    waterUsageE: "water_usage_E",
    wasteProductionE: "waste_production_E",
    biodiversityE: "biodiversity_E",
    communitySocietyS: "community_society_S",
    employeeRelationshipS: "employee_relationship_S",
    customerRelationshipS: "customer_relationship_S",
    humanRightsS: "human_rights_S",
    povertyFamineS: "poverty_famine_S",
    ethicalConsiderationsG: "ethical_considerations_G",
    strategyRiskManagementG: "strategy_risk_management_G",
    inclusivenessG: "inclusiveness_G",
    transparencyG: "transparency_G",
}

const ESG_SUBFACTOR_SETTINGS = {
    [ESG_SUBFACTOR_TYPE.emmisionsE]: {
        translationKey: "Report.ESG.Subfactor.Emmisions",
        translationData: {
            subfactorType: "Report.ESG.Subfactor.Emmisions"
        },
        tooltipKey: "Report.ESG.Subfactor.Tooltip.123",
    },
    [ESG_SUBFACTOR_TYPE.energyEfficiencyE]: {
        translationKey: "Report.ESG.Subfactor.EnergyEfficiency",
        translationData: {
            subfactorType: "Report.ESG.Subfactor.EnergyEfficiency"
        },
        tooltipKey: "Report.ESG.Subfactor.Tooltip.12",
    },
    [ESG_SUBFACTOR_TYPE.waterUsageE]: {
        translationKey: "Report.ESG.Subfactor.WaterUsage",
        translationData: {
            subfactorType: "Report.ESG.Subfactor.WaterUsage"
        },
        tooltipKey: "Report.ESG.Subfactor.Tooltip.12",
    },
    [ESG_SUBFACTOR_TYPE.wasteProductionE]: {
        translationKey: "Report.ESG.Subfactor.WasteProduction",
        translationData: {
            subfactorType: "Report.ESG.Subfactor.WasteProduction"
        },
        tooltipKey: "Report.ESG.Subfactor.Tooltip.23",
    },
    [ESG_SUBFACTOR_TYPE.biodiversityE]: {
        translationKey: "Report.ESG.Subfactor.Biodiversity",
        translationData: {
            subfactorType: "Report.ESG.Subfactor.Biodiversity"
        },
        tooltipKey: "Report.ESG.Subfactor.Tooltip.23",
    },
    [ESG_SUBFACTOR_TYPE.communitySocietyS]: {
        translationKey: "Report.ESG.Subfactor.CommunitySociety",
        translationData: {
            subfactorType: "Report.ESG.Subfactor.CommunitySociety"
        },
        tooltipKey: "Report.ESG.Subfactor.Tooltip.123",
    },
    [ESG_SUBFACTOR_TYPE.employeeRelationshipS]: {
        translationKey: "Report.ESG.Subfactor.EmployeeRelationship",
        translationData: {
            subfactorType: "Report.ESG.Subfactor.EmployeeRelationship"
        },
        tooltipKey: "Report.ESG.Subfactor.Tooltip.123",
    },
    [ESG_SUBFACTOR_TYPE.customerRelationshipS]: {
        translationKey: "Report.ESG.Subfactor.CustomerRelationship",
        translationData: {
            subfactorType: "Report.ESG.Subfactor.CustomerRelationship"
        },
        tooltipKey: "Report.ESG.Subfactor.Tooltip.12",
    },
    [ESG_SUBFACTOR_TYPE.humanRightsS]: {
        translationKey: "Report.ESG.Subfactor.HumanRights",
        translationData: {
            subfactorType: "Report.ESG.Subfactor.HumanRights"
        },
        tooltipKey: "Report.ESG.Subfactor.Tooltip.12",
    },
    [ESG_SUBFACTOR_TYPE.povertyFamineS]: {
        translationKey: "Report.ESG.Subfactor.PovertyFamine",
        translationData: {
            subfactorType: "Report.ESG.Subfactor.PovertyFamine"
        },
        tooltipKey: {
            "CZ": "Report.ESG.Subfactor.Tooltip.12",
            "SK": "Report.ESG.Subfactor.Tooltip.23"
        }
    },
    [ESG_SUBFACTOR_TYPE.ethicalConsiderationsG]: {
        translationKey: "Report.ESG.Subfactor.EthicalConsiderations",
        translationData: {
            subfactorType: "Report.ESG.Subfactor.EthicalConsiderations"
        },
        tooltipKey: "Report.ESG.Subfactor.Tooltip.123",
    },
    [ESG_SUBFACTOR_TYPE.strategyRiskManagementG]: {
        translationKey: "Report.ESG.Subfactor.StrategyRiskManagement",
        translationData: {
            subfactorType: "Report.ESG.Subfactor.StrategyRiskManagement"
        },
        tooltipKey: "Report.ESG.Subfactor.Tooltip.123",
    },
    [ESG_SUBFACTOR_TYPE.inclusivenessG]: {
        translationKey: "Report.ESG.Subfactor.Inclusiveness",
        translationData: {
            subfactorType: "Report.ESG.Subfactor.Inclusiveness"
        },
        tooltipKey: "Report.ESG.Subfactor.Tooltip.123",
    },
    [ESG_SUBFACTOR_TYPE.transparencyG]: {
        translationKey: "Report.ESG.Subfactor.Transparency",
        translationData: {
            subfactorType: "Report.ESG.Subfactor.Transparency"
        },
        tooltipKey: "Report.ESG.Subfactor.Tooltip.12",
    },
}

class ESGSubfactorStatistics extends React.Component {

    get settings() {
        return ESG_SUBFACTOR_SETTINGS[this.props.subfactor];
    }

    render() {
        return (isNullOrUndefined(this.props.data) ? <NoDataComponent /> : <div>{this.renderContent()}</div>);
    }

    renderContent() {
        const { subfactor, data, score, sectorIdentificator, primaryAttrCountry } = this.props;

        return (
            <RatingCard
                white
                cardType={subfactor}
                title={this.props.translate(this.settings.translationKey)}
                tooltip={ReactHtmlParser(this.props.translate(this.getTooltipKey(primaryAttrCountry)))}
                hasFooter={true}
                footer={
                    <div className='esg-subfactor-statistics-footer'>
                        <span>{this.props.translate("Report.ESG.DataSource")}:&nbsp;{data.source}</span>
                    </div>
                }
            >
                <EsgLine id={data.type} data={data} score={data.value} />
                <span><Translate id={`Report.ESG.Subfactor.Description.${score}`} data={this.getDescriptionKeyData(data, score, sectorIdentificator)} /></span>
            </RatingCard>
        )
    }

    getTooltipKey = (primaryAttrCountry) => this.settings.tooltipKey[primaryAttrCountry] ? this.settings.tooltipKey[primaryAttrCountry] : this.settings.tooltipKey;

    getDescriptionKeyData(data, score, sectorIdentificator) {
        let result = ({
            ...this.settings.translationData,
            subfactorType: this.props.translate(this.settings.translationData.subfactorType),
            sectorId: sectorIdentificator
        });

        switch (score) {
            case 1:
                result = ({ ...result, n_1: this.formatValue(data.n_1) });
                break;
            case 2:
                result = ({ ...result, n_2: this.formatValue(data.n_2) });
                break;
            case 3:
                result = ({ ...result, n_3: this.formatValue(data.n_3) });
                break;
            default:
                break;
        }

        return result;
    }


    formatValue(value) {
        if (value) {
            const digits = value < 1 ? 1 : 0;
            return value.toLocaleString(this.props.activeLanguage.code, { minimumFractionDigits: digits, maximumFractionDigits: digits });
        }
        return value;
    }
}

ESGSubfactorStatistics.ropTypes = {
    subfactor: PropTypes.oneOf([
        ESG_SUBFACTOR_TYPE.emmisionsE,
        ESG_SUBFACTOR_TYPE.energyEfficiencyE,
        ESG_SUBFACTOR_TYPE.waterUsageE,
        ESG_SUBFACTOR_TYPE.wasteProductionE,
        ESG_SUBFACTOR_TYPE.biodiversityE,
        ESG_SUBFACTOR_TYPE.communitySocietyS,
        ESG_SUBFACTOR_TYPE.employeeRelationshipS,
        ESG_SUBFACTOR_TYPE.customerRelationshipS,
        ESG_SUBFACTOR_TYPE.humanRightsS,
        ESG_SUBFACTOR_TYPE.povertyFamineS,
        ESG_SUBFACTOR_TYPE.ethicalConsiderationsG,
        ESG_SUBFACTOR_TYPE.strategyRiskManagementG,
        ESG_SUBFACTOR_TYPE.inclusivenessG,
        ESG_SUBFACTOR_TYPE.transparencyG
    ]).isRequired,
    score: PropTypes.oneOf([1, 2, 3, 4, 5]),
    data: PropTypes.shape({
        type: PropTypes.string,
        value: PropTypes.number,
        source: PropTypes.string,
        n_avg: PropTypes.number,
        n_1: PropTypes.number,
        n_2: PropTypes.number,
        n_3: PropTypes.number,
    }).isRequired,
    sectorIdentificator: PropTypes.string,
    primaryAttrCountry: PropTypes.oneOf(["CZ", "SK"])
};

ESGSubfactorStatistics.defaultProps = {
    subfactor: undefined,
    score: undefined,
    data: null,
    sectorIdentificator: "",
    primaryAttrCountry: "CZ"
};

export default withLocalize(ESGSubfactorStatistics);